import { projectStatus } from '@/constants'

const mixin = {
  computed: {
    projectStatuses () {
      const statuses = []

      for (const prop in projectStatus) {
        const id = projectStatus[prop]
        let name, icon, colorClass

        switch (id) {
          case projectStatus.active:
            name = this.$t('projectStatus.active')
            icon = 'mdi-circle-outline'
            colorClass = 'pBlue--text'
            break
          case projectStatus.planning:
            name = this.$t('projectStatus.planning')
            icon = 'mdi-circle-outline'
            colorClass = 'pYellow--text'
            break
          case projectStatus.cancelled:
            name = this.$t('projectStatus.cancelled')
            icon = 'mdi-close-circle-outline'
            colorClass = 'pRed--text'
            break
          case projectStatus.completed:
            name = this.$t('projectStatus.completed')
            icon = 'mdi-check-circle-outline'
            colorClass = 'pGreen--text'
            break
        }

        statuses.push({
          id,
          name,
          icon,
          class: colorClass
        })
      }
      return statuses
    }
  },


  methods: {
    getProjectStatusById (statusId) {
      return this.projectStatuses.find(el => el.id === statusId)
    }
  }
}

export default mixin
